<template>
	<button class="button__content d-flex justify-content-center align-items-center" @click="btnClick"
	        :class="{hover: parentHover}">
		<slot></slot>
	</button>
</template>

<script>
	export default {
		props: {
			
			parentHover: Boolean,
			link: String,
			itemdata: Object,
		},
		methods: {
			btnClick() {
				/*if (this.link == '' || this.link === undefined) {
					if (this.itemdata === undefined) {
						this.$root.show();
					} else {
						this.$root.show(this.itemdata)
					}
				} else {
					window.open(this.link, "_self")
				}*/
				
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	
	.button__content {
		background-color: transparent;
		border-radius: 6px;
		font-weight: 500;
		font-size: 14px;
		line-height: 18px;
		
		
		width: 100%;
		height: 100%;
	}
	
	.bordered-btn {
		border: 1px solid $activeColor;
		color: $activeColor;
		transition: all 0.3s ease-in-out;
		&:hover {
			border: 1px solid #FFFFFF;
			color: #FFFFFF;
			background-color: $activeColor;
		}
	}
	
	.normal-btn {
		border: 1px solid $activeColor;
		color: #FFFFFF;
		background-color: $activeColor;
		transition: all 0.3s ease-in-out;
		&:hover {
			border: 1px solid  $activeColor;
			color: $activeColor;
			background-color: #FFFFFF;
		}
	}


</style>